import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { useTranslation } from "react-i18next";
import { EmailTemplate } from "@types";

export const useGetEmailTemplates = () => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchEmailTemplates = async () => {
        try {
            const response = await axios.get<EmailTemplate[]>("/api/emailtemplates");
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getEmailTemplates"));
        }
    };

    return useQuery({ queryKey: ["emailTemplates"], queryFn: fetchEmailTemplates, staleTime: Infinity });
};